import { toFixed4 } from '../../DexTrades/formatters';

const formatPrice = (price: number | null, sign?: boolean): string =>
  price ? `${sign ? '$' : ''}${toFixed4(price)}` : '-';
const formatWallet = (wallet: string) =>
  `${wallet.slice(0, 6)}...${wallet.slice(wallet.length - 4)}`;

export { formatPrice, formatWallet };
